const getters = {
  username: state => state.username,
  userid: state => state.userid,
  connected: state => state.connected,
  players: state => state.players
}
export default getters
